import Vue from 'vue'
import Router from 'vue-router'
import Survey from '@/components/Survey'
import FormManager from '@/pages/FormManager'
import WelcomeGoodbye from '@/pages/WelcomeGoodbye'
import UserIdentification from '@/components/UserIdentification'
import Results from '@/components/Results'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      props: true,
      meta: {
        title: 'Recomendação de Exame'
      },
      component: WelcomeGoodbye,
      children: [{
        path: '',
        name: 'Bem vindo',
        component: UserIdentification
      },{
        path: '/resultados',
        name: 'Resultado',
        component: Results,
        props: true
      }]
    },
    {
      path: '/responder',
      name: 'Questionário',
      meta: {
        title: 'Recomendação de Exame'
      },
      component: FormManager
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js